import { render, staticRenderFns } from "./SkinTradeableChip.vue?vue&type=template&id=980a73be&scoped=true&"
import script from "./SkinTradeableChip.vue?vue&type=script&lang=ts&"
export * from "./SkinTradeableChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980a73be",
  null
  
)

export default component.exports